var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "modal-card", style: { minHeight: 60 + "vh" } },
    [
      _c("header", { staticClass: "modal-card-head" }, [
        _c("p", { staticClass: "modal-card-title" }, [
          _vm._v(" Upload Contract "),
        ]),
        _vm._v(
          " " +
            _vm._s(_vm.distributor.id) +
            "- " +
            _vm._s(_vm.distributor.name) +
            " "
        ),
        _c("button", {
          staticClass: "delete",
          attrs: { type: "button" },
          on: {
            click: function ($event) {
              return _vm.$emit("on-close")
            },
          },
        }),
      ]),
      _c("section", { staticClass: "modal-card-body" }, [
        _c(
          "section",
          { staticClass: "mt-2" },
          [
            _vm._l(_vm.files, function (file, index) {
              return _c(
                "div",
                {
                  key: index + "legalfile",
                  style: {
                    backgroundColor: "white",
                    width: "fit-content",
                    borderRadius: "25px",
                  },
                },
                [
                  _c(
                    "b-field",
                    { attrs: { grouped: "" } },
                    [
                      _c("b-field", { staticClass: "mt-2 ml-2" }, [
                        _vm._v(" " + _vm._s(file.fileName) + " "),
                      ]),
                      _c("b-button", {
                        staticClass: "left-right",
                        style: { display: "block", color: "black" },
                        attrs: { type: "is-ghost", "icon-left": "download" },
                        on: {
                          click: () => {
                            _vm.downloadFile(file)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              )
            }),
            _c(
              "b-field",
              { staticStyle: { "margin-top": "10px" } },
              [
                _c(
                  "b-upload",
                  {
                    attrs: { "drag-drop": "" },
                    on: { input: _vm.handleFileUpload },
                    model: {
                      value: _vm.dropFiles,
                      callback: function ($$v) {
                        _vm.dropFiles = $$v
                      },
                      expression: "dropFiles",
                    },
                  },
                  [
                    _c("section", { staticClass: "section" }, [
                      _c("div", { staticClass: "content has-text-centered" }, [
                        _c(
                          "p",
                          [
                            _c("b-icon", {
                              attrs: { icon: "upload", size: "is-large" },
                            }),
                          ],
                          1
                        ),
                        _c("p", [
                          _vm._v("Drop your file here or click to upload"),
                        ]),
                      ]),
                    ]),
                  ]
                ),
              ],
              1
            ),
            _c(
              "div",
              { staticClass: "tags" },
              _vm._l(_vm.dropFiles, function (file, index) {
                return _c(
                  "span",
                  { key: index, staticClass: "tag is-primary" },
                  [
                    _vm._v(" " + _vm._s(file.name) + " "),
                    _c("button", {
                      staticClass: "delete is-small",
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.deleteDropFile(index)
                        },
                      },
                    }),
                  ]
                )
              }),
              0
            ),
          ],
          2
        ),
      ]),
      _c("footer", { staticClass: "modal-card-foot" }, [
        _c(
          "div",
          { staticClass: "buttons" },
          [
            _c(
              "b-button",
              { attrs: { type: "is-primary" }, on: { click: _vm.submit } },
              [_vm._v(" Submit ")]
            ),
            _c(
              "b-button",
              {
                on: {
                  click: function ($event) {
                    return _vm.$emit("on-close")
                  },
                },
              },
              [_vm._v(" Cancel ")]
            ),
          ],
          1
        ),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }